import { Box, Typography } from "@mui/material";
import React from "react";
import useForm from "../Common/FormComponent/useForm";
import CommunicationHub from "../../services/api/CommunicationHub";

const UploadVideoWrapper = ({
  onUpload,
  UploadComponent,
  uploadComponentProps = {},
  url,
}) => {
  const form = useForm({
    callback_key: "",
    presign_url: "",
    download_url: "",
    file: null,
  });
  const { callback_key, presign_url, download_url, file } = form.values;

  const handleChange = async (file) => {
    //make api call
    const payload = {
      filename: file.name,
    };
    const { callback_key, upload_url, download_url } =
      await CommunicationHub.postVideo(payload);
    form.setFields({
      callback_key,
      presign_url: upload_url,
      download_url,
      file,
    });
  };
  const handleImageUpload = () => {
    onUpload && onUpload({ url: download_url, file });
    form.initForm();
  };

  return (
    <Box>
      <UploadComponent
        {...uploadComponentProps}
        handleVideoChange={handleChange}
        state="Add"
        imageKey={"thumbnail"}
        uploadUrl={"/communication_hub/upload_video/ack"}
        callback_key={callback_key}
        presign_url={presign_url}
        keyName="callback_key"
        videoUrl={url}
        maxSize={25}
        handleVideoUrlChange={handleImageUpload}
        noAckCall
      />
      {url && (
        <Typography
          variant="body2"
          color={"GrayText"}
          sx={{
            fontSize: "14px",
            fontStyle: "italic",
            position: "relative",
            top: -20,
          }}
        >
          Video uploaded
        </Typography>
      )}
    </Box>
  );
};

export default UploadVideoWrapper;
